var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnQt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14.6021,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_543_2195",
    transform: "matrix(0.0104167 0 0 0.00856039 0 0.0891013)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_543_2195",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADsklEQVR4nO2cO2tVQRRGh1iolS8QQVEROwuxsLUQHyg3lZXP+BfU+KriD/Bdi6VaqEWsVVD/gELsBBWDlS9CfJslE0bwRnPO7HPm3DNzZq8qyMzem/m4WW5MNEZRFEVRFEVRFEXpgxL6TyvB0QBaRgNomeQDIDGMcH4TOySGEc5vYofEMML5TeyQGEY4v4kdEsMI5zexQ2IY4fwmdkgMI5zfxA6JYYTzm9ghMYxwfhM7JIYRzm9ih8QwwvlN7JAYRji/6RrAMmCqgbedBlZUmCevACzA1QYCuGIqkGsAS4DJgI//1n6yKs6SXwAWYDfwI8Dj2xq7TEWyDcACHAV+1nh8e3dktphSDWAv8L7C478D9ui7BwBYCVwHvnk8vD1zzd7Rxw8MsAo4DowDL91fLafd1/bPjtkz+vCyR22V7MOiZTSAltEAWkYDaBkNoGU0gJbRAFom+wAURVEUxQIMD8C7vdlmSj/AYuDFAAKwPRbp+/8bwDkGx5gG0P/4G4AvAwzgs+2pITiAewye8T/9swaZeH3/SdKXYZMzyMV7xuPMWUG9vIWMTLxPgAUe54aAh4K6eQpZKN4pYKO7V4g7sx745Fk7TyELxXvkr3ulAbhzI4L6eQlZKN67c+56BeDO3hL0yWNDFop3cu6PlAsDWAq89uyVh5AF4p35348WSgJw53e6Wj50W8hC8V6ep4YoAHfnimfPbgtZIN7n9ltVwAAWAs+yFrJAvN+BrQV1xAG4e1sEW3IvZ/GeKqlVKQB393SWQhaI97HddhsMQLIlj+Um3o92g/WoVzkAd3+N5y98dEPIAvEe8qxXKwBX43AWQhaI946gZu0AXJ2bnRayQLxvgOUtBGC35FedFbKneGekv0gXKgBXa4fnljzWVfFerFA7WACu3qXOCdlTvBPzbbsDDsBuyU87I2RP8X4FNlesHzQAV3OT5ye21xXxjtboUUiNuidJXcie4n1Utu0WUVa8Rl27JT9IVsie4rXb7rqafQqpWdtnS45TyJ7iPRCgTyEB6h8kNSF7ivd2oF6FBOpxg1SE7Cle0bZbRNmrmAB4bslxCNlDvL+A7QH7FRKwzzY3e7xC9hTv+cA9Cwnc60LUQvYQ70TojyklBO7lsyWPxyreyttuLAEItuRejOI90VDvQhrqORqVkD3Ea7fdoQ4FMATcj0LIHuL9AKxtsH8hDfZd7f4jwHaF7CHe/Q33L6Th3vuS2pCbgBLanq/zoAFoAFmDfgIURVEURVEURTFp8xteKMhTxxyHHwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnQt);
export default __webpack_public_path__ + "static/media/enQt.cf2d7bbf1a1179dd1207ec60395fa782.svg";
export { ForwardRef as ReactComponent };